import { Button, Card, Col, Collapse, Form, Modal, Row, Spin, Table } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../components/PageTitle";
import { useAttachOrderTemplateToOrderSetMutation } from "../../features/organization/organizationService";
import OrderMedicationForm from "../../components/Orders/OrderMedicationForm";
const { Panel } = Collapse;

const CreateOrderTemplate = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const setName = params.get("setName") ?? "";
    const navigate = useNavigate(); 

    const [ attachOrderTemplateToOrderSet, {isLoading: attachIsLoading}] = useAttachOrderTemplateToOrderSetMutation();

    return (
        <div>
            <PageTitle title={`Add New Medication`} onClick={() => navigate(-1)} />
            <Card  bodyStyle={{ paddingLeft: 0 }}><span className="order-set-label fs-4 fw-semibold">{setName}</span></Card>
            <OrderMedicationForm isStructuredAllowed={false} isOrderTemplateCreation={true} cancelButton={
                        <Button
                            onClick={() => navigate(-1)}
                            className="text-light-blue form-button-width border-light-blue me-4"
                            shape="round"
                        >
                            Cancel
                        </Button>
                    } onSubmit={attachOrderTemplateToOrderSet} submitLabel={"Save"} isSubmitting={attachIsLoading} toastMessage={"Success!"} />
        </div>
    )
}

export default CreateOrderTemplate;